import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ANGULAR_MATERIAL_MODULES } from '../angular.material.modules';
import { GenericActionCellRendererComponent } from './components/generic-action-cell-renderer.component';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { HeatReclamationChartComponent } from '../modules/management/components/heat-reclamation-chart/heat-reclamation-chart.component';
import { NgxEchartsModule } from 'ngx-echarts';
import * as echarts from 'echarts';

@NgModule({
  declarations: [
    GenericActionCellRendererComponent,
    BreadcrumbComponent,
    HeatReclamationChartComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    NgxEchartsModule.forRoot({
      echarts
    }),
    ...ANGULAR_MATERIAL_MODULES
  ],
  exports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    GenericActionCellRendererComponent,
    BreadcrumbComponent,
    HeatReclamationChartComponent,
    ...ANGULAR_MATERIAL_MODULES
  ]
})
export class SharedModule { }